import { createRouter, createWebHashHistory } from "vue-router";

let routes = [];
routes = [
  {
    path: "/",
    name: "login",
    component: () => import("../components/Login.vue"),
  },
 
  {
    path: "/login",
    name: "login",
    component: () => import("../components/Login.vue"),
  },
 
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
